import SharpestWeekCard from '../../../components/profile/SharpestWeekCard'
import type { BestGameweekRecord } from '../../../components/profile/records'
import DemoFrame from './DemoFrame'

/**
 * The profile's own sharpest week card, frozen on the case the section exists to explain: a week
 * with Double Up on it, so the total on the face is double the base figure the week was actually
 * ranked on, and the line between them says so.
 *
 * A chip-free week would render one number and teach nothing.
 */
const DEMO_RECORD: BestGameweekRecord = {
  gameweek: 12,
  basePoints: 32,
  points: 64,
  correctOutcomes: 7,
  partialScores: 2,
  exactScores: 3,
  activeChips: ['doubleUp'],
  marks: ['win', 'blue', 'blue', 'muted', 'zero', 'win', 'blue', 'muted', 'blue', 'win'],
}

export default function SharpestWeekDemo() {
  return (
    <DemoFrame className="rules-demo--sharpest">
      <SharpestWeekCard record={DEMO_RECORD} />
    </DemoFrame>
  )
}
